import { Fragment } from 'react'

function RecordContent({ content, isEditing, editedContent, isSaving, isRewriting, onEditToggle, onSave, onContentChange, onRewriteClick }) {
    try {
        return (
            <div>
                <div className="flex justify-between items-center mb-1">
                    <h4 className="text-sm font-medium text-gray-700">原始轉換內容：</h4>
                    <div className="flex space-x-2">
                        {isEditing ? (
                            <Fragment>
                                <button
                                    onClick={onSave}
                                    className="text-sm px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition-colors flex items-center"
                                    disabled={isSaving}
                                    data-name="save-button"
                                >
                                    {isSaving ? (
                                        <Fragment>
                                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white mr-1"></div>
                                            儲存中...
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <i className="fas fa-save mr-1"></i>
                                            儲存
                                        </Fragment>
                                    )}
                                </button>
                                <button
                                    onClick={onEditToggle}
                                    className="text-sm px-3 py-1 bg-gray-300 text-gray-700 rounded hover:bg-gray-400 transition-colors"
                                    disabled={isSaving}
                                    data-name="cancel-button"
                                >
                                    <i className="fas fa-times mr-1"></i>
                                    取消
                                </button>
                            </Fragment>
                        ) : (
                            <Fragment>
                                <button
                                    onClick={onRewriteClick}
                                    className="text-sm px-3 py-1 bg-indigo-500 text-white rounded hover:bg-indigo-600 transition-colors flex items-center"
                                    disabled={isRewriting}
                                    data-name="rewrite-button"
                                >
                                    {isRewriting ? (
                                        <Fragment>
                                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white mr-1"></div>
                                            重寫中...
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <i className="fas fa-magic mr-1"></i>
                                            重寫內容
                                        </Fragment>
                                    )}
                                </button>
                                <button
                                    onClick={onEditToggle}
                                    className="text-sm px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                                    data-name="edit-button"
                                >
                                    <i className="fas fa-edit mr-1"></i>
                                    編輯
                                </button>
                            </Fragment>
                        )}
                    </div>
                </div>
                
                {isEditing ? (
                    <textarea
                        value={editedContent}
                        onChange={onContentChange}
                        className="w-full p-4 border border-gray-300 rounded-md h-96 focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
                        disabled={isSaving}
                        data-name="content-editor"
                    />
                ) : (
                    <div 
                        className="bg-white p-4 border border-gray-200 rounded-md max-h-96 overflow-y-auto whitespace-pre-wrap"
                        data-name="record-content-text"
                    >
                        {content}
                    </div>
                )}
            </div>
        );
    } catch (error) {
        console.error('RecordContent component error:', error);
        reportError(error);
        return null;
    }
}

export default RecordContent;